module.exports = __webpack_public_path__ + "static/img/fot1_act.4e27dcba.png";